import React, {FC, ReactElement} from "react";
import {Grid, MenuItem} from "@mui/material";
import {observer} from "mobx-react";
import {AlertColor} from "@mui/material/Alert/Alert";
import {FormikProps} from "formik/dist/types";
import {GetCompanySettingsDto} from "../../../model/company/GetCompanySettingsDto";
import TextFieldWithValidation from "../../../components/input/TextFieldWithValidation";
import {LOCALE_EN, LOCALE_ET, LOCALE_RU} from "../../../locale/i18";

export const ClientCommunicationCard: FC<{
    formik: FormikProps<GetCompanySettingsDto>
    showSnackBar: (messageType: AlertColor, messageText: string) => void
}> = observer(({formik}): ReactElement => {
    const clientCommunicationSettings = formik.values.clientCommunicationSettings

    return <>
        <Grid container alignItems="center" spacing={2}>
            <Grid item container xs={6}>
                <Grid item xs={12}>
                    <TextFieldWithValidation
                            select
                            name="clientCommunicationSettings.lang"
                            label="Preferred communication language"
                            value={clientCommunicationSettings.lang}
                            fullWidth={true}
                            onChange={formik.handleChange}
                    >
                        <MenuItem value={LOCALE_EN}>English</MenuItem>
                        <MenuItem value={LOCALE_ET}>Estonian</MenuItem>
                        <MenuItem value={LOCALE_RU}>Russian</MenuItem>
                    </TextFieldWithValidation>
                </Grid>
                <Grid item xs={12}>
                    <TextFieldWithValidation
                            name="clientCommunicationSettings.contactName"
                            label="Primary contact name"
                            value={clientCommunicationSettings.contactName}
                            fullWidth={true}
                            onChange={formik.handleChange}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextFieldWithValidation
                            name="clientCommunicationSettings.taxDepartmentBankReference"
                            label="Tax deparment bank reference"
                            value={clientCommunicationSettings.taxDepartmentBankReference}
                            fullWidth={true}
                            onChange={formik.handleChange}
                    />
                </Grid>
            </Grid>
        </Grid>
    </>
});